export const COST_CENTER_EVENT = 'CostCenterEvent';
export const COMMENT_EVENT = 'CommentEvent';
export const INVOICE_STATUS_EVENT = 'InvoiceStatusEvent';
export const INVOICE_MANUAL_PAYMENT_EVENT = 'InvoiceManualPaymentEvent';
export const INVOICE_RECEIVED_EVENT = 'InvoiceReceivedEvent';
export const INVOICE_STP_PAYMENT_EVENT = 'InvoiceSTPPaymentEvent';
